export enum LayoutEnum {
    DEFAULT = "",
    HORIZONTAL = "horizontal",
    SQUARE = "square",
    PACKAGE = "package",
}